document.addEventListener("DOMContentLoaded",function(){
    init();
});

const initiateTabs = () => {

    const closeActiveTab = tabGroupEl => {
        if(tabGroupEl.querySelector('.tbh-informational-tab__button--active')) {
            tabGroupEl.querySelector('.tbh-informational-tab__button--active').setAttribute('aria-expanded', false);
            tabGroupEl.querySelector('.tbh-informational-tab__button--active').classList.remove('tbh-informational-tab__button--active');
        }
        if(tabGroupEl.querySelector('.tbh-informational-tab--active')) {
            tabGroupEl.querySelector('.tbh-informational-tab--active').setAttribute('aria-expanded', false);
            tabGroupEl.querySelector('.tbh-informational-tab--active').classList.remove('tbh-informational-tab--active');
        }
    };

    if(document.querySelector('.tbh-informational-tab')) {
        // Open first tab on page load
        const tabGroupSections = document.querySelectorAll('.tbh-information-tab-group');
        tabGroupSections.forEach(tabGroupSection => {

            tabGroupSection.querySelector('.tbh-informational-tab__button').classList.add('tbh-informational-tab__button--active');
            tabGroupSection.querySelector('.tbh-informational-tab').classList.add('tbh-informational-tab--active');
            tabGroupSection.querySelector('.tbh-informational-tab__button').setAttribute('aria-expanded', true);

        });


        const informationalTabButtons = document.querySelectorAll('.tbh-informational-tab__button');

        informationalTabButtons.forEach(tabButton => {
            tabButton.addEventListener('click', () => {

                if(!tabButton.classList.contains('tbh-informational-tab__button--active')) {
                    const btnID = tabButton.id;
                    const btnNumber = btnID.slice(tabButton.id.indexOf('--') + 2);
                    const tabPanel = document.getElementById('tbh-informational-tab--'+ btnNumber);
    
                    if(tabPanel) {
                        const thisTabGroup = tabPanel.parentElement.parentElement;

                        closeActiveTab(thisTabGroup);

                        tabButton.classList.add('tbh-informational-tab__button--active');
                        tabPanel.classList.add('tbh-informational-tab--active');
                        tabButton.setAttribute('aria-expanded', true);
                    }

                } 

            });
        }); // endforeach
    }
};

const init = () => {
    initiateTabs();
};
